import './ProjectExportDropdown.scss';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useTranslator } from '@Localization';
import { Dropdown, IconButton, Menu, MenuButton, MenuItem } from '@mui/joy';
import { observer } from 'mobx-react-lite';
import { ReactElement } from 'react';

interface IProps {
  hasAllFilesGenerated: boolean;
  onAllDownloadClick: () => void;
  onAcceptedDownloadClick: () => void;
  onAnnotatedDownloadClick: () => void;
  onConfigDownloadClick: () => void;
}

export const ProjectExportDropdown = observer((props: IProps): ReactElement => {
  const { t } = useTranslator();

  const { onAllDownloadClick, onAcceptedDownloadClick, onAnnotatedDownloadClick, onConfigDownloadClick, hasAllFilesGenerated } = props;

  return (
    <Dropdown>
      <MenuButton
        slots={{ root: IconButton }}
        slotProps={{ root: { color: 'primary', size: 'sm' } }}
      >
        <FontAwesomeIcon icon={'download'} />
      </MenuButton>
      <Menu>
        <MenuItem
          onClick={onAllDownloadClick}
          className='project-export-dropdown-item'
        >
          {t('new.projects.details.export_data.everything')}
        </MenuItem>
        {hasAllFilesGenerated && (
          <>
            <MenuItem
              onClick={onAcceptedDownloadClick}
              className='project-export-dropdown-item'
            >
              {t('new.projects.details.export_data.all_accepted_data')}
            </MenuItem>
            <MenuItem
              onClick={onAnnotatedDownloadClick}
              className='project-export-dropdown-item'
            >
              {t('new.projects.details.export_data.all_annotated_data')}
            </MenuItem>
            <MenuItem
              onClick={onConfigDownloadClick}
              className='project-export-dropdown-item'
            >
              {t('new.projects.details.export_data.project_configuration_only')}
            </MenuItem>
          </>
        )}
      </Menu>
    </Dropdown>
  );
});
